
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

interface ReviewFormSubmitProps {
  isSubmitting: boolean;
  addressValidated: boolean;
  isEditing: boolean;
}

export const ReviewFormSubmit = ({ 
  isSubmitting, 
  addressValidated, 
  isEditing 
}: ReviewFormSubmitProps) => {
  const { language } = useLanguage();
  
  const getSubmitText = () => {
    if (isSubmitting) {
      return isEditing 
        ? (language === 'en' ? 'Updating...' : '更新中...')
        : (language === 'en' ? 'Submitting...' : '提交中...');
    }
    
    return isEditing 
      ? (language === 'en' ? 'Update Review' : '更新評價')
      : (language === 'en' ? 'Submit Review' : '提交評價');
  };
  
  // 調試：檢查按鈕狀態
  console.log("🔥 ReviewFormSubmit render:", { 
    isSubmitting, 
    addressValidated, 
    isEditing,
    disabled: isSubmitting || (!addressValidated && !isEditing)
  });

  return (
    <Button
      type="submit"
      className="w-full"
      disabled={isSubmitting || (!addressValidated && !isEditing)}
      onClick={(e) => {
        console.log("🔥🔥 Submit button clicked!", { 
          isSubmitting, 
          addressValidated, 
          isEditing, 
          disabled: isSubmitting || (!addressValidated && !isEditing),
          event: e.type,
          target: e.target,
          currentTarget: e.currentTarget
        });
      }}
    >
      {isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {getSubmitText()}
    </Button>
  );
};
